var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"dense":""}},[_c('system-disk-usage-widget'),_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-title',[_vm._v("User data")]),_c('v-card-text',[_c('system-storage-user-data')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }